// extracted by mini-css-extract-plugin
module.exports = {"container":"PackagesTypesTable_container__31HQO","tableContainer":"PackagesTypesTable_tableContainer__2TdLe"};